import React from 'react';
import { makersExperience } from '@fiverr-private/logo_maker_analytics';
import monitor from '../../../service/bigquery';
import { type TrackingData } from '../../../shared/lib/getTrackingData';
import { useOnceBeforeRender } from '../../../shared/hooks';
import MonogramsLogoIdeas from '../../components/MonogramsLogoIdeas/MonogramsLogoIdeas';

const { store: mixpanelStore } = makersExperience.monogramLogoIdeas;

interface ClientMonogramsLogoIdeasPageProps {
  tracking: TrackingData;
}

export default function ClientMonogramsLogoIdeasPage({ tracking }: ClientMonogramsLogoIdeasPageProps) {
  useOnceBeforeRender(() => {
    monitor.initialize(tracking);
    mixpanelStore.pageType.setData('Monograms');
  });

  return <MonogramsLogoIdeas refCtxId={tracking.refCtxId} />;
}
